// extracted by mini-css-extract-plugin
export default {"root":"n2xrZl","physicalLayout":"LNYNgf","icon":"aTo_UF","logicalLayout":"JnQAfl","visible":"wRGkgf","hidden":"JRUANI"};